import { render, staticRenderFns } from "./TabBeneficiaryHistoryTeleworkBudget.vue?vue&type=template&id=2070be4b&"
import script from "./TabBeneficiaryHistoryTeleworkBudget.vue?vue&type=script&lang=js&"
export * from "./TabBeneficiaryHistoryTeleworkBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports